import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { SharedEvent } from '../../../interfaces/shared.interface';
import { CollaborationService } from '../../../services/collaboration.service';
import { isEqual } from 'lodash';


@Component({
    selector: 'app-shared-reusable-component',
    template: '',
    styleUrls: []
})
export class SharedReusableComponent implements OnInit {
  private _sharedData!: any;
  private _atMentionConfig!: any;
  private _notificationConfig!: any;
  @Input()
  set sharedData(value: any) {
    if (this._sharedData !== value) {
      this._sharedData = value;
      this.initialize();
    }
  }

  get sharedData(): any {
    return this._sharedData;
  }
  
  @Input()
  set atMentionConfig(value: any) {
    if (this._atMentionConfig !== value) {
      this._atMentionConfig = value;
    }
  }

  get atMentionConfig(): any {
    return this._atMentionConfig;
  }

  @Input()
  set notificationConfig(value: any) {
    if (this._notificationConfig !== value) {
      this._notificationConfig = value;
    }
  }

  get notificationConfig(): any {
    return this._notificationConfig;
  }
  
  @Output() sharedDataEvent: EventEmitter<SharedEvent> = new EventEmitter<SharedEvent>();
  showLoader: boolean = true;
  constructor(public collaborationService: CollaborationService) { }

  ngOnInit(): void {
  }

  initialize() {
  }

  refreshWeavy() {
  }
}
